import React, { useContext, useState } from 'react';
import { HttpMethods, FetchContext, ApiRoutes, InsightContext, NavContext, NavRoutes } from '../../contexts';
import { useAggregatedState } from '../../../helpers';

export const HistoryContext = React.createContext(null);

const { Provider } = HistoryContext;

export const HistoryProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const { trackError } = useContext(InsightContext);
    const { navigateTo } = useContext(NavContext);

    const [ state, setState ] = useAggregatedState({
        requestDbType: null,
        history: null
    });

    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const loadRequestDbType = async (customerRequestId) => {
        try {
            setIsLoadingHistory(true);

            const response = await fetchAuthorized(
                ApiRoutes.Request.GetCustomerRequestDbType({ customerRequestId }),
                { method: HttpMethods.GET }
            );
            
            const requestDbType = await response.json();
            setState({ requestDbType });
        }
        catch(e) {
            console.error(e);
            trackError(e);
            setIsLoadingHistory(false);

            if (e.code === 403)
                navigateTo(NavRoutes.Forbidden);
        }
    };

    const loadHistory = async (customerRequestId, dbType) => {
        try {
            const response = await fetchAuthorized(
                ApiRoutes.Request.GetCustomerRequestHistory({ customerRequestId, dbType }),
                { method: HttpMethods.GET }
            );
            
            const history = await response.json();
            setState({ history });
        }
        catch(e) {
            trackError(e);
            console.error(e);
        }
        finally {
            setIsLoadingHistory(false);
        }
    };
    
    const [isDownloading, setIsDownloading] = useState(false);
    const downloadHistory = async (customerRequestId, dbType) => {
        try {
            setIsDownloading(true);

            const response = await fetchAuthorized(
                ApiRoutes.Request.GetRequestHistoryExcel({ customerRequestId, dbType }),
                { method: HttpMethods.GET }
            );

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "hystory.xlsx";
            document.body.appendChild(a); 
            a.click();    
            a.remove();
        }
        catch(e) {
            console.error(e);
            trackError(e);
        }
        finally {
            setIsDownloading(false);
        }
    };

    return (
        <Provider value={{  
            state,
            loadRequestDbType,
            isLoadingHistory,
            loadHistory,
            downloadHistory,
            isDownloading
        }}>
            {props.children}
        </Provider>
    );
}